// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1722) return "static/chunks/1722-7fe8fa6104f66231.js";
	if (chunkId === 5857) return "static/chunks/5857-e5ab8b56f4f006d7.js";
	if (chunkId === 370) return "static/chunks/370-b79cb3665fbba86b.js";
	if (chunkId === 7608) return "static/chunks/7608-4f237fef9916ad9b.js";
	if (chunkId === 6815) return "static/chunks/6815-ff038125ddfac65d.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 9923 ? "8e095c31" : chunkId) + "." + {"6592":"8afafa33097adb13","6942":"e748de91dde13178","7506":"af273a431f2cebfa","9233":"9e12a4497164cb5d","9923":"512e0f83378eedca"}[chunkId] + ".js";
};